/* This file is autogenerated, see readme.md for instructions */
import StatusDotSvgIcon from '@bloomreach/banana-theme/icons/status-dot.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StatusDotIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StatusDotSvgIcon />
    </Icon>
  );
});

StatusDotIcon.displayName = 'StatusDotIcon';

export default StatusDotIcon;
